import React from 'react';
import { connect } from '@gasbuddy/react';
import { FlexGrid } from '@gasbuddy/react-components';

import MainLayout from '../../components/main-layout';
import PageHeader from '../../components/page-header';
import StationListSelector from '../../components/station-list-selector-v2';
import CTAContainer from '../../components/cta-container';
import SharePageButton from '../../components/share-page-button';
import Notification from '../../components/notification';
import Table from '../../components/table';
import BPLink from '../../components/bp-link';
import BpUtils from '../../../lib/bputils';

import styles from './styles.css';

function SuggestedEdits() {
  const [stationListId, setStationListId] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [suggestedStationsMap, setSuggestedStationMap] = React.useState(null);
  const [suggestedStations, setSuggestedStations] = React.useState([]);

  const COLUMNS = [
    {
      title: 'Station',
      render: station => (
        <a
          href={`/client/station-profiles/station-profile?stationId=${station.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.stationLink}
        >
          {`#${station.retailer_reference} - ${station.retailer_name}`}
        </a>
      ),
      value: station => `#${station.retailer_reference} - ${station.retailer_name}`,
    },
    {
      title: 'Address',
      value: station => station.address.address,
    },
    {
      title: 'Cross Street',
      value: station => station.address.cross_street,
    },
    {
      title: 'City',
      value: station => station.address.city,
    },
    {
      title: 'State',
      value: station => station.address.state,
    },
    {
      title: '',
      render: station => <BPLink to={`/client/my-listings/suggested-edits/${station.id}`}>View Edits</BPLink>,
    },
  ];

  React.useEffect(() => {
    if (stationListId) {
      getStationIdsWithPendingEdits();
    }
  }, [stationListId]);

  React.useEffect(() => {
    if (suggestedStationsMap) {
      setSuggestedStations(Object.values(suggestedStationsMap));
    }
  }, [suggestedStationsMap]);

  const matchStationAddressToPendingEditIds = (stations, stationIdMap) => {
    const result = {};
    stations.forEach((station) => {
      if (stationIdMap[station.id]) {
        result[station.id] = station;
      }
    });
    setSuggestedStationMap(result);
    setIsLoading(false);
  };

  const getStationIdsWithPendingEdits = async () => {
    setIsLoading(true);
    await BpUtils.api.get({
      path: `/suggested-edits/station-lists/${stationListId}/pending`,
      data: {
        organization_id: 1,
        user_id: 0,
      },
      requestId: 'getStationIdsWithPendingEdits',
      success: (res) => {
        getBasicStationInfo(res || { });
      },
      error: () => Notification.error('We are unable to fetch your stations with suggested edits'),
    });
  };

  const getBasicStationInfo = async (stationIdMap) => {
    await BpUtils.api.get({
      path: `/station-lists/${stationListId}?response_type=full_stations`,
      requestId: 'getBasicStationInfoForEdits',
      success: res => matchStationAddressToPendingEditIds(res?.stations || [], stationIdMap),
      error: () => Notification.error('We we are unable to fetch your stations with suggested edits'),
    });
  };

  return (
    <MainLayout>
      <FlexGrid container>
        <FlexGrid.Column mobile={12} tablet={6}>
          <PageHeader title="Suggested Edits" />
          <div>
            <StationListSelector
              onChange={setStationListId}
              storeSelectedList
              createStationListOption
              searchable
            />
          </div>
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={6}>
          <CTAContainer alignment="right" style={{ paddingRight: '15px' }}>
            <SharePageButton gTagTitle="Suggested Edits - Share Report" />
          </CTAContainer>
        </FlexGrid.Column>
      </FlexGrid>
      {
        stationListId && (
          <FlexGrid container>
            <FlexGrid.Column className={styles.suggestedEditsTable}>
              <Table
                loading={isLoading}
                title="Pending Station Edits"
                tableColumns={COLUMNS}
                data={suggestedStations}
                paginator
              />
            </FlexGrid.Column>
          </FlexGrid>
        )
      }
    </MainLayout>
  );
}

export default connect()(SuggestedEdits);
